module.exports = __webpack_public_path__ + "static/media/Week 4 Friday.2ea407f5.png";